module.exports = __webpack_public_path__ + "static/weeks123_2-1381c3a5260f8a307bb6a72ea7d18d64.jpg";